<section class="recruiter-ai-features">
  <!-- Subtle dotted background pattern -->
  <div class="recruiter-ai-features__bg-pattern"></div>

  <div class="recruiter-ai-features__container">

    <!-- Header -->
    <div class="recruiter-ai-features__header">
      <div class="recruiter-ai-features__badge">
        AUTOMATION
      </div>
      <h2 class="recruiter-ai-features__title">
        AI handles the <span class="recruiter-ai-features__title-highlight">heavy lifting</span>
      </h2>
      <p class="recruiter-ai-features__subtitle">
        Let intelligent workflows do the repetitive work while your team focuses on great hires.
      </p>
    </div>

    <!-- Features Grid -->
    <div #featuresGrid class="recruiter-ai-features__grid">
      @for (feature of features; track feature.title) {
      <div class="recruiter-ai-features__card">
        <div class="recruiter-ai-features__icon-wrapper">
          @switch (feature.icon) {
          @case ('scan') {
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <path d="M3 7V5a2 2 0 0 1 2-2h2"></path>
            <path d="M17 3h2a2 2 0 0 1 2 2v2"></path>
            <path d="M21 17v2a2 2 0 0 1-2 2h-2"></path>
            <path d="M7 21H5a2 2 0 0 1-2-2v-2"></path>
            <line x1="8" y1="12" x2="16" y2="12"></line>
          </svg>
          }
          @case ('clipboard') {
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
            <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
            <line x1="9" y1="10" x2="15" y2="10"></line>
            <line x1="9" y1="14" x2="15" y2="14"></line>
            <line x1="9" y1="18" x2="13" y2="18"></line>
          </svg>
          }
          @case ('video') {
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <polygon points="23 7 16 12 23 17 23 7"></polygon>
            <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
          </svg>
          }
          @case ('shield') {
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            <path d="M9 12l2 2 4-4"></path>
          </svg>
          }
          @case ('chart') {
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <line x1="18" y1="20" x2="18" y2="10"></line>
            <line x1="12" y1="20" x2="12" y2="4"></line>
            <line x1="6" y1="20" x2="6" y2="14"></line>
          </svg>
          }
          @case ('users') {
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
          }
          }
        </div>
        <h3 class="recruiter-ai-features__card-title">{{ feature.title }}</h3>
        <p class="recruiter-ai-features__card-desc">{{ feature.description }}</p>
      </div>
      }
    </div>

    <!-- CTA Button -->
    <div class="recruiter-ai-features__action">
      <!-- <button class="recruiter-ai-features__btn">
        Explore All AI Features
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <line x1="5" y1="12" x2="19" y2="12"></line>
          <polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </button> -->
    </div>

  </div>
</section>